"use client";

import { Button, Input, LoadingSpinner } from "@wtc/ui";
import { RotateCw, Search } from "lucide-react";
import type { ClientFolder } from "./SaveAttachmentsToGoogleDriveModal.types";

interface ClientFolderPickerProps {
  clientFolders: ClientFolder[];
  isRefreshing: boolean;
  listingLoading: boolean;
  onRefreshFolders: () => void;
  onSearchTermChange: (term: string) => void;
  onSelectClient: (folder: ClientFolder) => void;
  searchTerm: string;
  selectedClient: ClientFolder | null;
}

export function ClientFolderPicker({
  clientFolders,
  isRefreshing,
  listingLoading,
  onRefreshFolders,
  onSearchTermChange,
  onSelectClient,
  searchTerm,
  selectedClient,
}: ClientFolderPickerProps) {
  return (
    <>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search clients..."
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
            className="pl-10"
          />
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={onRefreshFolders}
          disabled={listingLoading || isRefreshing}
          title="Refresh folder list"
          className={isRefreshing ? "animate-spin" : ""}
        >
          {listingLoading || isRefreshing ? (
            <LoadingSpinner className="h-4 w-4" />
          ) : (
            <RotateCw className="h-4 w-4" />
          )}
        </Button>
      </div>

      <div className="border rounded-lg max-h-48 overflow-y-auto">
        {clientFolders.length === 0 ? (
          <div className="p-4 text-center text-sm text-muted-foreground">
            {searchTerm ? "No clients found matching your search" : "No client folders found"}
          </div>
        ) : (
          <div className="divide-y">
            {clientFolders.map((folder) => (
              <button type="button"
                key={folder.id}
                onClick={() => onSelectClient(folder)}
                className={`w-full text-left px-4 py-2 hover:bg-muted transition-colors text-sm ${
                  selectedClient?.id === folder.id ? "bg-primary/10 border-l-2 border-primary" : ""
                }`}
              >
                <div className="font-medium">{folder.name}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
